import { render, staticRenderFns } from "./IBeaconMessageListView.vue?vue&type=template&id=8b95bedc&scoped=true"
import script from "./IBeaconMessageListView.vue?vue&type=script&lang=js"
export * from "./IBeaconMessageListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b95bedc",
  null
  
)

export default component.exports